import { makeObservable, observable } from 'mobx';

import { LaboratoryReferenceTableList } from '@lab/ui/LaboratoryAdmin/pages/LaboratoryReferencesTablePage/store/LaboratoryReferenceTableList';
import { LaboratoryReferenceList } from '@lab/ui/LaboratoryAdmin/pages/LaboratoryReferencesTablePage/store/LaboratoryReferenceList';

export class LaboratoryReferencesPageStore {
    public static Name = 'laboratoryReferencesPageStore' as const;

    @observable public laboratoryReferenceTableList: LaboratoryReferenceTableList = new LaboratoryReferenceTableList();
    @observable public laboratoryReferenceList: LaboratoryReferenceList = new LaboratoryReferenceList();

    public constructor() {
        makeObservable(this);
    }
}

export const laboratoryReferencesPageStore = new LaboratoryReferencesPageStore();
